import React, { useState, useCallback, useContext } from "react";
import styled from "styled-components";
import EditPic from "../../../SVGs/Edit.svg";
import CustomTextField from "../../Common/CustomTextField";
import CustomTextArea from "../../Common/CustomTextArea";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { UserContext } from "../../../Context/user_context";
import PageLoader from "../../Common/PageLoader";

function OtherInformation({ data, contactId, refetchData }) {
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [otherInfo, setOtherInfo] = useState(false);
  const [height, setHeight] = useState(data ? data.new_height : "");
  const [weight, setWeight] = useState(data ? data.new_weight : "");
  const [medications, setMedications] = useState(
    data ? data.new_currentmedicationsconditions : ""
  );

  const handleOtherInfo = useCallback(() => {
    setOtherInfo(!otherInfo);
  }, [otherInfo]);

  const handleUpdateRecord = async () => {
    setIsLoading(true);
    const userid = contactId
      ? contactId
      : Cookies.get("hippocratic_portal_contactid");
    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: [
        {
          fieldname: "new_height",
          value: height,
          type: "string",
          entity: null,
        },
        {
          fieldname: "new_weight",
          value: weight,
          type: "string",
          entity: null,
        },
        {
          fieldname: "new_currentmedicationsconditions",
          value: medications,
          type: "string",
          entity: null,
        },
        ...(user.hip_initialportalinfoupdate ? [] : [{
          fieldname: "hip_initialportalinfoupdate",
          value: "910310000",
          type: "optionset",
          entity: null,
        }])
      ],
    };

    try {
      await getApiClient().updateRecord(recordData);
      if (!user.hip_initialportalinfoupdate) {
        setUser({
          ...user,
          hip_initialportalinfoupdate: true
        });
      }
      toast.success("Information has been updated successfully");
      // Refetch data to get updated information
      if (refetchData) {
        await refetchData();
      }
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setOtherInfo(!otherInfo);
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Sectoin>
        <TopPart>
          <SubTitle>Other Information</SubTitle>
          {otherInfo ? (
            <Save onClick={handleUpdateRecord}>Save Changes</Save>
          ) : (
            <Edit
              onClick={() => {
                handleOtherInfo();
              }}
            >
              Edit
              <img style={{ height: "19px" }} src={EditPic} alt="edit-icon" />
            </Edit>
          )}
        </TopPart>
        <BottomPart>
          <FieldsContainer>
            <CustomTextField
              Active={otherInfo}
              Title="Height:"
              value={height}
              onChange={setHeight}
            />
            <CustomTextField
              Active={otherInfo}
              Title="Weight:"
              value={weight}
              onChange={setWeight}
            />
          </FieldsContainer>
          <FieldsContainer>
            <CustomTextArea
              Active={otherInfo}
              Title="Current Medications/Conditions:"
              value={medications}
              onChange={setMedications}
            />
          </FieldsContainer>
        </BottomPart>
      </Sectoin>
    </>
  );
}

const Sectoin = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TopPart = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const Edit = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #87a9bf;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 10px;
  text-decoration-line: underline;
`;

const BottomPart = styled.div`
  display: grid;
  min-height: 100px;
  gap: 30px;
  width: 100%;
  grid-template-columns: 1fr 2fr;
  justify-items: center;
align-items: start;

  @media screen and (max-width: 684px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

const SubTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const FieldsContainer = styled.div`
  display: flex;
  gap: 5px;
align-items: flex-start
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const Save = styled.div`
  border-radius: 300px;
  background: #304961;
  padding: 5px 10px;

  cursor: pointer;

  color: #fff;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default OtherInformation;
